import React from "react";
// Notice the capital 'I' for the folder, and lowercase 'i' for the file based on your screenshots!
import GetinTouch from "./GetinTouchNew/GetinTouchNew";

const Contact = () => {
  return (
    <>
      <GetinTouch />
    </>
  );
};

export default Contact;